module.exports = __webpack_public_path__ + "img/lifeBlock_1_zh.be6e761b.png";